import React from "react";

export function BurgerMenuStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;

    return {
        "& .menu-burger-container": {
            display: "none",

            [MobileBreakpoint]: {
                display: "block",

                "& .burger-menu-btn": {
                    display: "grid",
                    gridGap: "5px",
                    padding: "16px",
                    position: "relative",
                },

                "& .burger-menu-btn.active": {
                    pointerEvents: "none",
                },

                "& .burger-menu-btn span": {
                    display: "block",
                    width: "30px",
                    height: "2px",
                    backgroundColor: palette.primary.initialText,
                },

                "& .burger-menu": {
                    background: palette.primary.initial + " !important",
                    fontSize: "18px !important",
                    color: palette.primary.initialText + " !important",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    padding: "15px",
                    transform: "translateX(-100%)",
                    transition: "transform 0.5s",
                },

                "& .burger-menu.active": {
                    transform: "translateX(0)",
                },

                "& .burger-menu-btn-close": {
                    width: "30px",
                    position: "fixed",
                    top: "40px",
                    right: "10px",
                },

                "& .burger-menu-btn-close span": {
                    position: "absolute",
                    width: "30px",
                    height: "2px",
                    backgroundColor: palette.primary.initialText,
                    top: "50%",
                    transform: "translate(-50%, 0%) rotate(-45deg)",
                },

                "& .burger-menu-btn-close span:nth-of-type(2)": {
                    top: "50%",
                    transform: "translate(-50%, 0%) rotate(45deg)",
                },
            },
        },
    };
}

export default function BurgerMenu(props) {
    const [isMenuShowing, setIsMenuShowing] = React.useState();

    const onMenuShowChange = () => {
        setIsMenuShowing(!isMenuShowing);
    };

    const CNMenu = ["burger-menu"];
    const CNBurgerMenuButton = ["burger-menu-btn"];
    isMenuShowing && CNMenu.push("active");
    isMenuShowing && CNBurgerMenuButton.push("active");

    return (
        <div className="menu-burger-container">
            <div className={CNBurgerMenuButton.join(" ")} onClick={onMenuShowChange}>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div className={CNMenu.join(" ")} onClick={onMenuShowChange}>
                <div className="burger-menu-btn-close" onClick={onMenuShowChange}>
                    <span></span>
                    <span></span>
                </div>

                {props.children}
            </div>
        </div>
    );
}
